// extracted by mini-css-extract-plugin
export default {"slider":"x1ZqJsMZfmSeU6xTWqKV","inputContainer":"yo9WMFtW4VYoRfo1Kp9o","duration":"zqRFklUKSCGRdUhr8mcx"};